import { useCallback } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import useWindowSize from './useWindowSize';
import { deviceViewportArray } from '../constants/DeviceViewports';

function useDeviceViewport() {
  const { width } = useWindowSize();

  const getCurrentViewport = useCallback(() => {
    const viewports = cloneDeep(deviceViewportArray).reverse();
    let matchingViewport;
    viewports.forEach((viewport) => {
      const { name: viewportName, value: viewportValue } = viewport;
      if (width >= viewportValue) {
        matchingViewport = viewportName;
      }
    });
    return matchingViewport;
  }, [width]);

  return getCurrentViewport() || null;
}

export default useDeviceViewport;
